import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { getSyncRun, listSyncRuns, type SyncRunListPage } from '../../../api/syncJobs';
import { SyncRunsGrid } from './components/SyncRunsGrid';

export function SyncJobRunsPage() {
  const navigate = useNavigate();
  const { name } = useParams<{ name: string }>();
  const jobName = name ?? '';

  const loadPage = useCallback(
    (request: Omit<Parameters<typeof listSyncRuns>[0], 'jobName'>): Promise<SyncRunListPage> =>
      listSyncRuns({ jobName, ...request }),
    [jobName]
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <SyncRunsGrid
          loadPage={loadPage}
          loadDetails={getSyncRun}
          showJobName={false}
          stateStorageKey={`webopsui:admin-sync-runs-grid:v2:${jobName || 'all'}`}
          onBackToJobs={() => navigate('/admin/sync-jobs')}
        />
      </div>
    </div>
  );
}
